import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import rest from "../../rest";
import { Paper, CircularProgress, Typography } from "@material-ui/core";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import UserCard from "./UserCard";
import {
  extractUniqueParentNoms,
  filterUsers,
  calculateTotalHours,
  isInDateAndTimeRange,
} from "./utils";
import FilterForm from "./FilterForm";
import HorizontalStepper from "./Stepper";
import ScrollToTopButton from "../../components/general/ScrollToTopButton";
import ButtonConfirm from "../../components/general/ButtonConfirm";
import IconButtonStyled from "../../components/general/IconButtonStyled";
import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
const initialSteps = [
  { label: "À traiter", colorClass: "step-button-red", type: "wish" },
  {
    label: "À finaliser",
    colorClass: "step-button-yellow",
    type: "preValider",
  },
  { label: "Validé", colorClass: "step-button-green", type: "valide" },
  {
    label: "Liste d'attente",
    colorClass: "step-button-green",
    type: "listeAttente",
  },
];

const Attributions = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedParent, setSelectedParent] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");
  const distinctParent = extractUniqueParentNoms(users);
  const [chefOnIds, setChefOnIds] = useState([]);
  const [reload, setReload] = useState(false);
  const [steper, setSteper] = useState(false);
  const [steps, setSteps] = useState(initialSteps);
  const [activeStep, setActiveStep] = useState(steps[0]);
  const [triCroissant, setTriCroissant] = useState(true);
  // Les options de trie (defaut: alphabetique)
  const [trie, setTrie] = useState("alphabetique");
  const [search, setSearch] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [snack, setSnack] = useState({});

  const [uniqueDates, setUniqueDates] = useState([]);
  const [uniqueStartTimes, setUniqueStartTime] = useState([]);
  const [uniqueEndTimes, setUniqueEndTime] = useState([]);

  const manifParams = useSelector((state) => state.manif);
  const currentUser = useSelector((state) => state.user);

  useEffect(() => {
    setIsLoaded(false);
    setSteps(initialSteps);
    let id = null;
    /*   if (currentUser.User.User_Administrator && selectedParent) { */
    if (selectedParent) {
      id = selectedParent.id || selectedParent.ID;
    }
    getListUsers(id);
  }, [reload, selectedParent, currentUser]);

  const getListUsers = (id) => {
    let params = {};
    if (id) {
      params.idActivite = id;
    }
    rest
      .post("/benevols/attribution/listeBenevoles.json", params)
      .then((response) => {
        setUsers(response.data.users.allUser);
        setIsLoaded(true);
        setChefOnIds(response.data.users.actionsIds);
        setSteper(true);
        setSelectedUserIds([]); // remettre a zero les user selectionner
      })
      .catch((error) => {
        setSnack({ message: error, show: true, severity: "error" });
        console.error("There was an error fetching the data!", error);
        setIsLoaded(true);
      });
  };

  useEffect(() => {
    if (!(selectedParent?.id || chefOnIds[0]?.ID)) return;
    rest
      .post("/tableauDesAttributions/tranchesActivite.json", {
        idActivite: selectedParent?.id || chefOnIds[0]?.ID,
      })
      .then((response) => {
        setUniqueDates(response.data.dates);
        setUniqueStartTime(response.data.timeDebut);
        setUniqueEndTime(response.data.timeFin);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }, [selectedParent, chefOnIds]);

  useEffect(() => {
    if (users.length > 0 && selectedParent?.nom !== "") {
      let filteredUsers = filterUsers(users, activeStep, selectedParent);
      const parentId = selectedParent?.id || selectedParent?.ID;

      if (activeStep?.type !== "listeAttente") {
        // Filtrer les utilisateurs en fonction des critères spécifiés
        filteredUsers = filteredUsers.filter((user) =>
          user.wish?.tranches?.some((tranche) => {
            return (
              tranche.parentId === parentId &&
              isInDateAndTimeRange(
                tranche,
                startDate,
                endDate,
                startTime,
                endTime
              )
            );
          })
        );
      } else {
        // Filtrer les utilisateurs en fonction des critères spécifiés
        filteredUsers = filteredUsers.filter((user) =>
          user.wish?.tranches?.some((tranche) => {
            return isInDateAndTimeRange(
              tranche,
              startDate,
              endDate,
              startTime,
              endTime
            );
          })
        );
      }

      // Trie et recherche
      const filtered = filteredUsers.filter(
        (b) =>
          b.Name.toLowerCase().includes(search.toLowerCase()) ||
          b.Firstname.toLowerCase().includes(search.toLowerCase())
      );

      let sorted = [];

      switch (trie) {
        /* case "dispos":
          if (triCroissant) {
            sorted = filtered.sort(
              (a, b) => b.wish?.tranches.length - a.wish?.tranches.length
            );
          } else {
            sorted = filtered.sort(
              (a, b) => a.wish?.tranches.length - b.wish?.tranches.length
            );
          }
          break; */
        case "dispos":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => {
              const aCount =
                a?.wish?.tranches.filter(
                  (t) => t.parentId === selectedParent?.id
                ).length || 0;
              const bCount =
                b?.wish?.tranches.filter(
                  (t) => t.parentId === selectedParent?.id
                ).length || 0;
              const lengthDiff = aCount - bCount;
              return lengthDiff !== 0
                ? lengthDiff
                : a.Name.localeCompare(b.Name);
            });
          } else {
            sorted = filtered.sort((a, b) => {
              const aCount =
                a?.wish?.tranches.filter(
                  (t) => t.parentId === selectedParent?.id
                ).length || 0;
              const bCount =
                b?.wish?.tranches.filter(
                  (t) => t.parentId === selectedParent?.id
                ).length || 0;
              const lengthDiff = bCount - aCount;
              return lengthDiff !== 0
                ? lengthDiff
                : b.Name.localeCompare(a.Name);
            });
          }
          break;
        case "experience":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => {
              const hoursA = calculateTotalHours(a, parentId);
              const hoursB = calculateTotalHours(b, parentId);
              return hoursB - hoursA;
            });
          } else {
            sorted = filtered.sort((a, b) => {
              const hoursA = calculateTotalHours(a, parentId);
              const hoursB = calculateTotalHours(b, parentId);
              return hoursA - hoursB;
            });
          }
          break;
        case "alphabetique":
          if (triCroissant) {
            sorted = filtered.sort((a, b) => a.Name.localeCompare(b.Name));
          } else {
            sorted = filtered.sort((a, b) => b.Name.localeCompare(a.Name));
          }
          break;
        case "date":
          if (triCroissant) {
            sorted = filtered.sort(
              (a, b) => a.lastInscription - b.lastInscription
            );
          } else {
            sorted = filtered.sort(
              (a, b) => b.lastInscription - a.lastInscription
            );
          }
          break;
        default:
          sorted = filtered;
      }

      filteredUsers = sorted;
      setFilteredUsers(filteredUsers);
      setSelectedUserIds([]); // Remettre à zéro les utilisateurs sélectionnés
    }
  }, [
    users,
    selectedParent,
    startDate,
    endDate,
    startTime,
    endTime,
    activeStep,
    triCroissant,
    trie,
    search,
  ]);

  useEffect(() => {
    if (activeStep.type === "listeAttente") setSteper(false);
    else setSteper(true);
  }, [activeStep]);

  const handleSelectTrieChange = (event) => {
    setTrie(event.target.value);
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleOrderChange = () => {
    setTriCroissant((prev) => !prev);
  };

  useEffect(() => {
    if (chefOnIds.length > 0 && selectedParent === null) {
      setSelectedParent({ ...chefOnIds[0], id: chefOnIds[0].ID });
    }
  }, [chefOnIds, selectedParent]);

  const handleParentChange = (event) => {
    let activite = distinctParent.find(
      (activite) => activite.id === event.target.value
    );
    if (!activite) {
      activite = chefOnIds.find(
        (activite) => activite.ID === event.target.value
      );
      if (activite) activite.id = activite.ID;
    }
    setSelectedParent(activite);
    setStartDate("");
    setStartTime("");
    setEndDate("");
    setEndTime("");
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);
  };

  const handleValidAll = () => {
    let usersIds = selectedUserIds;
    if (usersIds?.length === 0) {
      filteredUsers.map((user) => {
        usersIds.push(user.ID);
        return false;
      });
    }
    rest
      .post("/benevols/attribution/addMultiUsersTranche.json", { usersIds })
      .then((response) => {
        setReload((set) => !set);
      })
      .catch((error) => {
        console.error("There was an error exporting billetterie!", error);
        setSnack({ message: error, show: true, severity: "error" });
      });
  };

  const handleCheckboxChange = (userId) => {
    setSelectedUserIds((prevSelected) =>
      prevSelected.includes(userId)
        ? prevSelected.filter((id) => id !== userId)
        : [...prevSelected, userId]
    );
  };

  const handelExportBilletterie = () => {
    rest
      .get("/export/billeterie/csv", { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "billetterie.zip"); // Nom du fichier à télécharger
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("There was an error exporting billetterie!", error);
        setSnack({ message: error, show: true, severity: "error" });
      });
  };

  if (!isLoaded) {
    return <CircularProgress />;
  }

  return (
    <Paper style={{ minHeight: "100vh", padding: "20px" }}>
      <MySnackbar params={snack} />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Attributions
        </Typography>
        <div>
          {activeStep?.type === "preValider" && (
            <ButtonConfirm
              onConfirm={handleValidAll}
              text={
                selectedUserIds.length === 0
                  ? "Valider tous les plannings visibles"
                  : `
              Valider le${selectedUserIds.length > 1 ? "s" : ""} 
              planning${selectedUserIds.length > 1 ? "s" : ""} 
              sélectionné${selectedUserIds.length > 1 ? "s" : ""} (${
                      selectedUserIds.length
                    })`
              }
              textConfirm={
                selectedUserIds.length === 0
                  ? "Confirmer tout valider"
                  : "Confirmer valider"
              }
              variant="contained"
              color="successDarkBtn"
              style={{ marginRight: 10 }}
              icon={<AssignmentTurnedInIcon />}
              position={"left-end"}
            />
          )}
          {activeStep?.type === "valide" && (
            <IconButtonStyled
              color="blueBtn"
              style={{ marginRight: 10 }}
              onClick={handelExportBilletterie}
              tooltipTitle="Exporter billetterie"
            >
              <CardMembershipIcon />
            </IconButtonStyled>
          )}
        </div>
      </div>
      <FilterForm
        search={search}
        handleSearch={handleSearch}
        trie={trie}
        handleSelectTrieChange={handleSelectTrieChange}
        triCroissant={triCroissant}
        selectedParent={selectedParent}
        handleParentChange={handleParentChange}
        chefOnIds={chefOnIds}
        handleOrderChange={handleOrderChange}
        startDate={startDate}
        handleStartDateChange={handleStartDateChange}
        startTime={startTime}
        handleStartTimeChange={handleStartTimeChange}
        endDate={endDate}
        handleEndDateChange={handleEndDateChange}
        endTime={endTime}
        handleEndTimeChange={handleEndTimeChange}
        uniqueDates={uniqueDates}
        uniqueStartTimes={uniqueStartTimes}
        uniqueEndTimes={uniqueEndTimes}
        sousActiviteName={manifParams.manifInfos.DenominationSousAct}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        steps={steps}
      />
      {steper && (
        <HorizontalStepper
          activeStep={activeStep || {}}
          stepOptions={steps}
          activeActivity={selectedParent}
          selectedParent={selectedParent}
          setActiveStep={setActiveStep}
          users={users}
          steps={steps}
        />
      )}
      {filteredUsers.map((user, index) => (
        <UserCard
          handleCheckboxChange={handleCheckboxChange}
          key={`${user.ID}-${index}`}
          setReload={setReload}
          user={user}
          activeActivity={selectedParent}
          handleParentChange={handleParentChange}
          chefOnIds={chefOnIds}
          activeStep={activeStep}
          distinctParent={distinctParent}
          sousActivite={manifParams.manifInfos.DenominationSousAct}
        />
      ))}
      <p style={{ marginTop: 400 }} />
      <ScrollToTopButton />
    </Paper>
  );
};

export default Attributions;
